import { render } from "./Loader.vue?vue&type=template&id=a79a1b5e&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=a79a1b5e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79a1b5e"]])

export default __exports__